import React from 'react';
import { Provider } from 'react-redux';
import createStore from './redux/create';

import './App.css';

import AppRouter from './components/routers/AppRouter';

const store = createStore();

export default function App() {
  return (
    <Provider store={store}>
      {/*<DataInit/>*/}
      <AppRouter />
    </Provider>
  );
}

// const App: React.FC = () => {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.tsx</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }
//
// export default App;
